export default {
  en: {  }
};